import { useEffect, useRef, useState } from "react";
import { Column } from "../../../../core/components/Column";
import { NavItem } from "../../../../core/components/NavItem";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";
import { useLocation } from "react-router-dom";

export const Aside: React.FC = () => {
	const [isMenuOpen, setIsMenuOpen] = useState(window.innerWidth <= 768 ? true : false);
	const menuRef = useRef<HTMLDivElement>(null);
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (window.innerWidth <= 768 && menuRef.current && !menuRef.current.contains(event.target as Node)) {
				setIsMenuOpen(true);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [isMenuOpen]);
	const location = useLocation();

	useEffect(() => {
		if (window.innerWidth <= 768) setIsMenuOpen(true);
	}, [location.pathname]);

	return (
		<>
			<header className={`sticky shadow z-20 top-0 bg-white py-2 md:hidden`}>
				<button
					onClick={() => setIsMenuOpen(!isMenuOpen)}
					type="button"
					className="p-2 rounded-md text-black hover:text-primary cursor-pointer "
					aria-controls="mobile-menu"
					aria-expanded={isMenuOpen}
				>
					<svg
						className="w-6 h-6"
						aria-hidden="true"
						fill="currentColor"
						viewBox="0 0 20 20"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							clipRule="evenodd"
							fillRule="evenodd"
							d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
						></path>
					</svg>
				</button>
			</header>
			{!isMenuOpen && <div className="fixed md:hidden z-20 h-screen w-full max-md:bg-[#00000060]" />}
			<Column
				ref={menuRef}
				crossAxisAlignment="center"
				className={`md:shadow max-md:fixed top-0 left-0 z-20 min-w-fit max-md:h-full transition-transform  max-md:max-w-[3rem] 
					${isMenuOpen ? "-translate-x-full" : "translate-x-0"} bg-white sticky top-0 gap-4 max-md:py-4`}
			>
				<Column
					crossAxisAlignment="center"
					className="gap-2 md:hidden  w-full"
				>
					<TextComponent
						variant="h1"
						className="uppercase font-bold text-darkPurple text-center py-4 md:py-16 flex-wrap px-8"
					>
						Opciones
					</TextComponent>
					<div className="h-[1px] w-full bg-darkPurple" />
				</Column>
				<Row
					className="bg-white md:py-4 w-full md:w-[45rem] xl:w-[60rem] uppercase"
					mainAxisAlignment="center"
					responsiveWrap
					responsiveCol
				>
					<NavItem
						title="Principal"
						href="/"
						hiddenText={isMenuOpen}
						variant="primary"
					/>
					<NavItem
						title="Estilistas"
						href="/estilistas"
						hiddenText={isMenuOpen}
						variant="primary"
					/>
					<NavItem
						title="RESTAURANTES"
						href="/restaurantes"
						hiddenText={isMenuOpen}
						variant="primary"
					/>
					<NavItem
						title="Discotecas"
						href="/discotecas"
						hiddenText={isMenuOpen}
						variant="primary"
					/>
					<NavItem
						title="LUGARES TÍPICOS"
						href="/lugares_tipicos"
						hiddenText={isMenuOpen}
						variant="primary"
					/>
					<NavItem
						title="Mirabus"
						href="/mirabus"
						hiddenText={isMenuOpen}
						variant="primary"
					/>
					<NavItem
						title="Aventura"
						href="/aventura"
						hiddenText={isMenuOpen}
						variant="primary"
					/>
					<NavItem
						title="Cine"
						href="/cine"
						hiddenText={isMenuOpen}
						variant="primary"
					/>
					<NavItem
						title="HOTELES"
						href="/hoteles"
						hiddenText={isMenuOpen}
						variant="primary"
					/>
				</Row>
			</Column>
		</>
	);
};
